import * as THREE from 'three'

import Sizes from './utils/Sizes.js'
import Time from './utils/Time.js'
import Resources from './utils/Resources.js'
import Camera from './Camera.js'
import Renderer from './Renderer.js'
import Sources from './Sources.js'
import ParticleObjects from './ParticleObjects.js'
import ObjectsLoader from './ObjectsLoader.js'
import GUI from './GUI.js'
import Raycast from './Raycast.js'

let instance = null

export default class Experience
{
    constructor(canvas)
    {
        if (instance) {return instance}

        instance = this

        window.experience = this
        
        this.canvas = canvas

        this.sizes = new Sizes()
        this.sizes.on('resize', () => {this.resize()})
        
        this.time = new Time()
        this.time.on('tick', () => {this.update()})
        
        this.scene = new THREE.Scene()
        this.scene.background = new THREE.Color(0x003A49)
        this.resources = new Resources([Sources])
        this.camera = new Camera()
        this.renderer = new Renderer()
        
        this.objectsLoader = new ObjectsLoader()
        this.particleObjects = new ParticleObjects()
        this.gui = new GUI()
        this.raycast = new Raycast()

        this.isMobile = false

        this.activateUI();
    }

    activateUI()
    {
        ScrollTrigger.maxScroll(window, 1);
        /*ScrollTrigger.create({
            trigger: "main",
            start: "top top",
            endTrigger: "footer",
            end: "bottom bottom",
            markers: true,
            overwrite: true,
            onUpdate: (self) => { 
                var s = self.progress.toFixed(3)*100;
                console.log('SCROLL', s); 
                this.camera.setScrollValue(s); 
            },
            scrub: true
          })*/
        let sections = document.querySelectorAll('.sec');
        sections.forEach((sec, i) => {
            let strty = (i == 0) ? "top top" : "top 50%";
            ScrollTrigger.create({
                trigger: sec,
                start: strty,
                end: "bottom 50%",
                //markers: true,
                overwrite: true,
                onUpdate: (self) => { 
                    var s = Math.min(100, ((self.progress * 100 / 8) + (12.5 * i)).toFixed(2));
                    // console.log(i+1, Math.floor(self.progress*100), s); 
                    this.camera.setScrollValue(s); 
                },
                scrub: true
              })
        })
    }

    resize()
    {
        this.camera.resize()
        
        this.renderer.resize()
    }

    update()
    {
        //this.resources.update()

        this.camera.update()
        
        this.particleObjects.update()
        
        this.raycast.update()

        this.renderer.update()
    }
}